import {
  ADMIN_REPORT_ITEMS,
  hasAdminPermission,
  hasAnyReportPermission,
} from "../../../Util/adminPermissions";
import {
  FaBell,
  FaCalendarAlt,
  FaChartLine,
  FaLayerGroup,
  FaUser,
} from "react-icons/fa";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { Link, useLocation, useNavigate } from "react-router";
import { IoIosArrowForward } from "react-icons/io";
import { MdSpaceDashboard } from "react-icons/md";
import { RootState } from "../../../Redux/store";
import { RiCoupon2Fill } from "react-icons/ri";
import styles from "./Sidebar.module.scss";
import { useSelector } from "react-redux";

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { adminPermissions } = useSelector((state: RootState) => state.auth);

  const can = (permission: string) =>
    hasAdminPermission(adminPermissions, permission);

  const showReports = hasAnyReportPermission(adminPermissions);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.linksContainer}>
        {can("dashboard_view") && (
          <Link
            to="/admin"
            className={`${styles.link} ${
              location.pathname === "/admin" || location.pathname === "/admin/"
                ? styles.active
                : ""
            }`}
          >
            <MdSpaceDashboard />
            <p>Home</p>
          </Link>
        )}
        {can("buildings_view") && (
          <Link
            to="/admin/buildings"
            className={`${styles.link} ${location.pathname?.includes("/admin/buildings") ? styles.active : ""}`}
          >
            <FaCalendarAlt />
            <p>Buildings</p>
          </Link>
        )}
        {can("groups_view") && (
          <Link
            to="/admin/groups"
            className={`${styles.link} ${location.pathname?.includes("/admin/groups") ? styles.active : ""}`}
          >
            <FaLayerGroup />
            <p>Groups</p>
          </Link>
        )}

        {can("members_view") && (
          <Link
            to="/admin/members"
            className={`${styles.link} ${location.pathname?.includes("/admin/members") ? styles.active : ""}`}
          >
            <FaUser />
            <p>Members</p>
          </Link>
        )}
        {can("members_view") && (
          <Link
            to="/admin/nonmembers"
            className={`${styles.link} ${location.pathname?.includes("/admin/nonmembers") ? styles.active : ""}`}
          >
            <FaUser />
            <p>Non Members</p>
          </Link>
        )}
        {can("members_view") && (
          <Link
            to="/admin/freemembers"
            className={`${styles.link} ${location.pathname?.includes("/admin/freemembers") ? styles.active : ""}`}
          >
            <FaUser />
            <p>Free Members</p>
          </Link>
        )}
        {can("roles_view") && (
          <Link
            to="/admin/roles"
            className={`${styles.link} ${location.pathname?.includes("/admin/roles") ? styles.active : ""}`}
          >
            <FaUser />
            <p>Roles</p>
          </Link>
        )}
        {can("users_view") && (
          <Link
            to="/admin/users"
            className={`${styles.link} ${location.pathname?.includes("/admin/users") ? styles.active : ""}`}
          >
            <FaUser />
            <p>Users</p>
          </Link>
        )}

        {can("vouchers_view") && (
          <Link
            to="/admin/coupons"
            className={`${styles.link} ${location.pathname?.includes("/admin/coupons") ? styles.active : ""}`}
          >
            <RiCoupon2Fill />
            <p>Coupons</p>
          </Link>
        )}

        {can("notification_view") && (
          <Link
            to="/admin/notifications"
            className={`${styles.link} ${location.pathname?.includes("/admin/notifications") ? styles.active : ""}`}
          >
            <FaBell />
            <p>Notify</p>
          </Link>
        )}

        {showReports && (
          <Menu
            menuClassName={styles.sidebarDropdown}
            dir="right"
            align="end"
            viewScroll="auto"
            arrow={true}
            transition={true}
            portal={true}
            direction="left"
            menuButton={
              <MenuButton
                className={`${styles.link} ${location.pathname?.includes("/admin/reports") ? styles.active : ""}`}
              >
                <div className={styles.linkTextContainer}>
                  <span className={styles.linkText}>
                    <FaChartLine />
                    <p>Reports</p>
                  </span>
                  <span className={styles.menuIcon}>
                    <IoIosArrowForward />
                  </span>
                </div>
              </MenuButton>
            }
          >
            {ADMIN_REPORT_ITEMS.filter((item) => can(item.permission)).map(
              (item) => (
                <MenuItem
                  key={item.path}
                  onClick={() => {
                    if (location.pathname === item.path) {
                      return;
                    }
                    navigate(item.path);
                  }}
                >
                  {item.label}
                </MenuItem>
              ),
            )}
          </Menu>
        )}
      </div>
    </div>
  );
}

export default Sidebar;
